// ═══════════════════════════════════════════════════════════════════
//  composants/Sparkline.js
//  Sparkline
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";

export function Sparkline({ values, color, height = 30 }) {
  if (!values || values.length < 2 || values.every((v) => v === 0))
    return <div style={{ height, opacity: 0.3, color: THEME.textDim, fontSize: 10, display: "flex", alignItems: "flex-end" }}>—</div>;
  const W = 120, H = height, max = Math.max(...values), min = Math.min(...values), span = max - min || 1;
  const pts = values.map((v, i) => [(i / (values.length - 1)) * W, H - ((v - min) / span) * (H - 4) - 2]);
  const line = pts.map((p) => p.join(",")).join(" ");
  const id = "sg" + color.replace("#", "");
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} preserveAspectRatio="none">
      <defs><linearGradient id={id} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity="0.35" /><stop offset="100%" stopColor={color} stopOpacity="0" /></linearGradient></defs>
      <polygon points={`0,${H} ${line} ${W},${H}`} fill={`url(#${id})`} />
      <polyline points={line} fill="none" stroke={color} strokeWidth="2" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
